import { atom } from 'recoil';
import type { ResumeOnsa } from '../types/onsaTypes';

export const resumeOnsaAtom = atom<ResumeOnsa>({
    key: 'resumeOnsaAtom',
    default: ((): ResumeOnsa => {
        const searchParams = new URLSearchParams(window.location.search);
        const getParamValue = (param: string): string => searchParams.get(param) ?? '';
        return {
            jobNumber: getParamValue('jobId'),
            sessionId: getParamValue('sessionId')
        };
    })()
});
